import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, forkJoin, BehaviorSubject } from "rxjs";
import { take, map } from "rxjs/operators";
import { Location } from '@angular/common'
import { CustomerJourneyService } from '../data/customer-journey.service';
import { ProgressStateUiService } from './progress-state-ui.service';
import { ContractType } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class CjProcessNavUiService {
  private cSigSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(
    private router: Router,
    private cjInputService: CustomerJourneyService,

    private progressStateUiService: ProgressStateUiService,
  ) { }
  public get cSig$(): Observable<string> {
    return this.cSigSubject.asObservable();
  }

  public setCSig(cSig: string): void {
    this.cSigSubject.next(cSig);
  }
  public postCjInputResponse(model: ContractType): void {
    const cSig = this.cSigSubject.value;
    this.progressStateUiService.deferProgressUntill(this.cjInputService.postCJData(model));
    
    this.router.navigate(['/progress'], {
      queryParamsHandling: 'merge',
      queryParams: {
        source: 'isWaitPageCounterInserted',
        'c-sig': cSig
      }
    });

    }
}
